import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationEN from "./locales/en/translation.json";

i18n.use(reactI18nextModule).init({
  resources: {
    en: {
      translation: translationEN,
    },
  },
  lng: window.localStorage.getItem("lang") || "en",
  fallbackLng: "en",
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js